import React, {useState} from 'react'
import ShareButton from "./share_button";
import {useTracking} from "src/shared/virtual_congress/effects/use_tracking";
import Countdown from "react-countdown";
import moment from "moment";
import SupportPopup from "./support_popup";

const renderer = ({days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return null
  } else {
    return <div className={"event-countdown p-2"} style={{minWidth: "295px"}}>
      <span>
        Event starts in:
        {"    "}
        <strong>{days}d {hours}h {minutes}m</strong>
      </span>
    </div>
  }
};

export default function BottomLeftMenu({imageMap, hideShareButtons, hideEventCountdown, ...props}) {
  const track = useTracking()
  const [showSupportModal, setShowSupportModal] = useState(false)
  const shareUrl = "https://iot.a1.net/exhibition/public_dashboard"

  const enabled_shareTypes = [
    "Facebook",
    "Twitter",
    "Linkedin",
    "Email",
  ];

  return <>
    {showSupportModal && <SupportPopup onModalClose={() => setShowSupportModal(false)} />}
    <div className={"bottom-left-menu-container"}>
      <div className="row no-gutters">
        <div className="col-12">
          <div className="bottom-left-menu-item" style={{cursor: "pointer"}} onClick={() => {
            track("support_clicked")
            setShowSupportModal(true)
          }}>
            <span className={"align-middle"} style={{paddingRight: "1rem"}}>
              {"Support             "}
            </span>
            <i className="fa fa-headset align-middle"/>
          </div>
        </div>
        {!hideShareButtons && <div className="col-12">
          <div className="bottom-left-menu-item">
            <span className={"align-middle"} style={{paddingRight: "1rem"}}>
              Invite a Friend
            </span>
            {enabled_shareTypes.map((type) => {
              return <div key={"nav" + type} style={{paddingRight: "5px", display: "inline"}}>
                <ShareButton key={type}
                             info={{
                               title: "Einladung: Virtual A1 IoT Day",
                               via: "Hier ist eine Einladung für Sie: Virtual A1 IoT Day 2020 mit Toto Wolff.",
                               summary: "Hier ist eine Einladung für Sie: Virtual A1 IoT Day 2020 mit Toto Wolff.",
                               quote: "Hier ist eine Einladung für Sie: Virtual A1 IoT Day 2020 mit Toto Wolff.",
                               subject: "Einladung: Virtual A1 IoT Day", body: "Hier ist eine Einladung für Sie: Virtual A1 IoT Day 2020 mit Toto Wolff."
                             }}
                             type={type}
                             url={shareUrl}/>
              </div>
            })}
          </div>
        </div>}
        {!hideEventCountdown && <div className="col-12">
          <Countdown date={moment.parseZone("2020-11-23T17:30:00+01:00").toDate()} renderer={renderer} />
        </div>}
      </div>
    </div>
  </>
}